export function LoadingSpinner(props) {
  return (
    <div className="text-center">
      <img src="/images/green-spinner.gif" alt="Loading ..." />
    </div>
  );
}
